class ProductsGridVideos extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
    }

    connectedCallback() {
        this.initSwiper();
        this.initVideoControls();
        this.ensureVideoAttributes();
    }

    initSwiper() {
        if (!this.classList.contains('swiper')) return;

        this.swiper = new Swiper(this, {
            centeredSlides: true,
            slidesPerView: 'auto',
            initialSlide: 1,
            navigation: {
                nextEl: document.querySelector('.video-graduate__graduate .swiper-next'),
                prevEl: document.querySelector('.video-graduate__graduate .swiper-prev'),
            },
            pagination: {
                el: document.querySelector('.video-graduate__graduate .swiper-pagination'),
                clickable: true,
            },
            on: {
                init: () => {
                    this.updateSlideClasses();
                    this.pauseOtherVideos();
                    this.querySelectorAll('.video-block').forEach((b) => this.resetVideoUI(b));
                },
                slideChange: () => {
                    this.updateSlideClasses();
                    this.pauseOtherVideos();
                },
            },
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    initialSlide: 0,
                    centeredSlides: false,
                },
            }
        });
    }


    // --- Helpers videos/Slides ---
    getActiveSlide() {
        return this.swiper?.slides?.[this.swiper.activeIndex] || null;
    }

    getActiveVideo() {
        const slide = this.getActiveSlide();
        return slide?.querySelector('.video-block video') || null;
    }

    playActiveVideo() {
        const video = this.getActiveVideo();
        if (!video) return;
        video.play().catch(() => {
            // Si le navigateur bloque l'autoplay
        });
    }

    updateSlideClasses() {
        const slides = this.querySelectorAll('.swiper-slide');
        const activeIndex = this.swiper?.activeIndex ?? 0;
        slides.forEach((slide, i) =>
            slide.classList.toggle('slide-before-active', i < activeIndex)
        );
    }

    pauseOtherVideos() {
        const activeSlide = this.getActiveSlide();
        this.querySelectorAll('.video-block').forEach((block) => {
            const video = block.querySelector('video');
            if (!video) return;
            if (!activeSlide || !activeSlide.contains(block)) {
                video.pause();
                this.resetVideoUI(block);
            }
        });
    }

    pauseOtherVideosExcept(currentVideo) {
        this.querySelectorAll('video').forEach((v) => {
            if (v !== currentVideo) {
                v.pause();
                const block = v.closest('.video-block');
                if (block) this.resetVideoUI(block);
            }
        });
    }

    ensureVideoAttributes() {
        // Important pour iOS et l'autoplay (on garde muted au démarrage pour l'autoplay)
        this.querySelectorAll('video').forEach((v) => {
            v.setAttribute('playsinline', '');
            v.setAttribute('webkit-playsinline', '');
            // On initialise en muted pour l'autoplay mobile, mais l'utilisateur peut activer le son
            if (!v.hasAttribute('data-user-interacted')) {
                v.muted = true;
            }
        });
    }

    // --- UI helpers ---
    syncVideoUI(videoBlock, isPlaying) {
        const show = (sel, on) => {
            const el = videoBlock.querySelector(sel);
            if (el) el.classList.toggle('hidden', !on);
        };
        show('.video-poster', !isPlaying);
        show('.video-section__play-button', !isPlaying);
        show('.video-section__pause-button', isPlaying);
        const playIcon = videoBlock.querySelector('.video-section__play-icon');
        if (playIcon) playIcon.classList.toggle('hidden', isPlaying);
    }

    resetVideoUI(videoBlock) {
        this.syncVideoUI(videoBlock, false);
    }

    initVideoControls() {
        // Poster -> play
        this.querySelectorAll('.video-poster').forEach((poster) => {
            poster.addEventListener('click', () => {
                const videoBlock = poster.closest('.video-block');
                const video = videoBlock?.querySelector('video');
                if (video) {
                    video.setAttribute('data-user-interacted', 'true');
                    // Activer le son lors du premier clic utilisateur
                    video.muted = false;
                    video.play();
                }
            });
        });

        // Boutons Play/Pause
        this.querySelectorAll('.video-section__play-button').forEach((btn) => {
            btn.addEventListener('click', () => {
                const video = btn.closest('.video-block')?.querySelector('video');
                if (video) {
                    video.setAttribute('data-user-interacted', 'true');
                    video.muted = false;
                    video.play();
                }
            });
        });
        
        this.querySelectorAll('.video-section__pause-button').forEach((btn) => {
            btn.addEventListener('click', () => {
                btn.closest('.video-block')?.querySelector('video')?.pause();
            });
        });

        // Clic direct sur la vidéo -> toggle play/pause
        this.querySelectorAll('video').forEach((video) => {
            const block = video.closest('.video-block');

            video.addEventListener('play', () => {
                this.pauseOtherVideosExcept(video);
                this.syncVideoUI(block, true);
            });

            video.addEventListener('pause', () => this.syncVideoUI(block, false));
            video.addEventListener('ended', () => this.syncVideoUI(block, false));

            video.addEventListener('click', () => {
                video.setAttribute('data-user-interacted', 'true');
                if (video.paused) {
                    video.muted = false;
                    video.play();
                } else {
                    video.pause();
                }
            });
        });

        // Mute / Unmute
        this.querySelectorAll('.video-section__mute-button, .video-section__unmute-button').forEach((button) => {
            button.addEventListener('click', () => {
                const videoBlock = button.closest('.video-block');
                const video = videoBlock.querySelector('video');
                if (!video) return;
                
                video.setAttribute('data-user-interacted', 'true');
                video.muted = !video.muted;

                const muteBtn = videoBlock.querySelector('.video-section__mute-button');
                const unmuteBtn = videoBlock.querySelector('.video-section__unmute-button');
                if (muteBtn && unmuteBtn) {
                    muteBtn.classList.toggle('hidden', !video.muted);
                    unmuteBtn.classList.toggle('hidden', video.muted);
                }
            });
        });
    }

    disconnectedCallback() {
        this.swiper?.destroy();
    }
}

customElements.define('products-grid-videos', ProductsGridVideos);